import { render, staticRenderFns } from "./DangerSignBar.vue?vue&type=template&id=0ba11596&scoped=true"
import script from "./DangerSignBar.vue?vue&type=script&lang=ts"
export * from "./DangerSignBar.vue?vue&type=script&lang=ts"
import style0 from "../styles/danger-sign-bar.css?vue&type=style&index=0&id=0ba11596&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba11596",
  null
  
)

export default component.exports